import { t } from 'i18next';

import FreeGatedContent from '~/pages/post/FreeGatedContent';

import { SubscriberGate } from '~/components/Actions/types';

import type { Publication } from '~/interfaces/publication';

import PrivateHeader from './PrivateHeader';

interface PrivatePublictionProps {
  publication: Publication;
}

const PrivatePublication = ({ publication }: PrivatePublictionProps) => {
  return (
    <>
      <PrivateHeader publication={publication} />

      {publication.private && (
        <FreeGatedContent
          title={t('gated.private_newsletter.title')}
          message={t('gated.private_newsletter.message')}
          cta={publication.cta_text}
          publication={publication}
        />
      )}

      {!publication.private && publication.require_subscriber_approval && (
        <FreeGatedContent
          title={t('gated.require_approval.title')}
          message={t('gated.require_approval.message')}
          cta={publication.cta_text}
          publication={publication}
          createActionType={SubscriberGate.NONE}
        />
      )}
    </>
  );
};

export default PrivatePublication;
